import { render, staticRenderFns } from "./AddUpdateArea.vue?vue&type=template&id=697af2b7&"
import script from "./AddUpdateArea.vue?vue&type=script&lang=js&"
export * from "./AddUpdateArea.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports